var _path, _rect, _rect2, _path2, _ellipse, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileHwp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32 0C1.93413 0 0 1.93413 0 4.32V31.68C0 34.0659 1.93413 36 4.32 36H31.68C34.0659 36 36 34.0659 36 31.68V4.32C36 1.93413 34.0659 0 31.68 0H4.32Z",
    fill: "#1D4861"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.4356,
    y: 7,
    width: 3.28355,
    height: 2.51102,
    fill: "#48B1F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.8417,
    y: 9.51102,
    width: 12.3299,
    height: 2.51102,
    fill: "#48B1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21.6092C20.4019 21.6092 22.3491 19.6238 22.3491 17.1747C22.3491 14.7256 20.4019 12.7402 18 12.7402C15.5981 12.7402 13.6509 14.7256 13.6509 17.1747C13.6509 19.6238 15.5981 21.6092 18 21.6092ZM18 19.2441C19.1209 19.2441 20.0296 18.3176 20.0296 17.1746C20.0296 16.0317 19.1209 15.1052 18 15.1052C16.8791 15.1052 15.9704 16.0317 15.9704 17.1746C15.9704 18.3176 16.8791 19.2441 18 19.2441Z",
    fill: "#48B1F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 24.2276,
    rx: 1.53255,
    ry: 1.56264,
    fill: "#48B1F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23.4252,
    width: 2.44378,
    height: 5.57478,
    fill: "#48B1F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26.5082,
    width: 2.49178,
    height: 14,
    transform: "rotate(90 25 26.5082)",
    fill: "#48B1F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileHwp);
export default __webpack_public_path__ + "static/media/file-hwp.c74484cbe438319a05e65e88f789c187.svg";
export { ForwardRef as ReactComponent };